export const auth = {
  /**
   * 检查存储中的账号信息（localStorage 或 sessionStorage）
   * @returns {Object|null} 返回账号信息或 null
   */
  getStoredUser() {
    const user = JSON.parse(localStorage.getItem("agent_user")) || JSON.parse(sessionStorage.getItem("agent_user"));
    // 修改：只要有 id 就认为有效，不再要求 password
    return user && user.id ? user : null;
  },

  /**
   * 保存账号信息到存储中
   * @param {Object} user 包含用户信息的对象（id, username, password等）
   * @param {Boolean} remember 是否记住账号
   */
  saveUser(user, remember) {
    const storage = remember ? localStorage : sessionStorage;
    storage.setItem("agent_user", JSON.stringify(user));
  },

  /**
   * 清除存储中的用户信息
   */
  clearUser() {
    localStorage.removeItem("agent_user");
    sessionStorage.removeItem("agent_user");
  },

  /**
   * 自动跳转逻辑
   * @param {Object} router Vue Router 实例
   */
  autoRedirect(router) {
    const user = this.getStoredUser();
    if (user) {
      router.push({ path: "/home/merchant-management" });
    }
  },
};